<div id="preloader">
    <div class="jumper">
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>  
<!-- ***** Preloader End ***** -->

<!-- Header removed: global header is now provided by <app-header> -->

<h3> Car Details</h3>
<div>
    <div>
        <label> <b> CarId: </b></label> {{car.carId}}
    </div>
    <div>
        <label> <b> CarName: </b></label> {{car.carName}}
    </div>
    <div>
        <label> <b> Offer: </b></label> {{car.offer}}
    </div>
    <div>
        <label> <b> price: </b></label> {{car.price}}
    </div>
</div>
<!--<table>
    <tr>
        <td>CarId</td>
        <td>{{car.carId}}</td>
    </tr>
    <tr>
        <td>CarName</td>
        <td>{{car.carName}}</td>
    </tr>
    <tr>
        <td>Offer</td>
        <td>{{car.offer}}</td>
    </tr>
    <tr>
        <td>Price</td>
        <td>{{book.price}}</td>
    </tr>
</table>-->
<br>
<img src="/assets/img/car_0.jpg" height="100px" width="100px">
<br><br>